import React, { useState, useEffect } from 'react';
import { getReminders, createReminder, completeReminder, deleteReminder } from '../utils/api';
import { ar, en } from '../utils/translations';

const ReminderModal = ({ contactType, contactId, contactName, onClose, language = 'ar' }) => {
  const t = language === 'ar' ? ar : en;
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    reminder_date: ''
  });

  useEffect(() => {
    loadReminders();
  }, [contactType, contactId]);

  const loadReminders = async () => {
    try {
      setLoading(true);
      const response = await getReminders(contactType, contactId);
      setReminders(response.data);
    } catch (error) {
      console.error('Error loading reminders:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createReminder({
        contact_type: contactType,
        contact_id: contactId,
        ...formData
      });
      setFormData({ title: '', reminder_date: '' });
      setShowAddForm(false);
      loadReminders();
    } catch (error) {
      console.error('Error creating reminder:', error);
      alert(t.failedToSave);
    }
  };

  const handleComplete = async (id) => {
    try {
      await completeReminder(id);
      loadReminders();
    } catch (error) {
      console.error('Error completing reminder:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm(t.deleteReminderConfirm)) {
      try {
        await deleteReminder(id);
        loadReminders();
      } catch (error) {
        console.error('Error deleting reminder:', error);
      }
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px' }}>
        <div className="modal-header">
          <h2>{t.reminders} - {contactName}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        {!showAddForm ? (
          <div>
            <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0 }}>{t.upcomingReminders}</h3>
              <button className="btn btn-primary" onClick={() => setShowAddForm(true)}>
                ➕ {t.addReminder}
              </button>
            </div>
            
            {loading ? (
              <p>{t.loading}</p>
            ) : reminders.length === 0 ? (
              <div className="empty-state">
                <p>{t.noReminders}</p>
              </div>
            ) : (
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {reminders.map((reminder) => (
                  <div key={reminder.id} style={{
                    padding: '15px',
                    marginBottom: '10px',
                    background: reminder.reminder_date < new Date().toISOString() ? '#ffe8cc' : '#faf5f0',
                    borderRadius: '8px',
                    borderLeft: '4px solid #ffd4a3'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                      <div style={{ flex: 1 }}>
                        <strong>{reminder.title}</strong>
                        <p style={{ margin: '4px 0', fontSize: '0.9rem', opacity: 0.7 }}>
                          ⏰ {new Date(reminder.reminder_date).toLocaleString(language === 'ar' ? 'ar-SA' : 'en-US')}
                        </p>
                      </div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                          className="btn btn-success btn-small"
                          onClick={() => handleComplete(reminder.id)}
                          style={{ padding: '4px 8px', fontSize: '0.8rem' }}
                        >
                          ✓
                        </button>
                        <button
                          className="btn btn-secondary btn-small"
                          onClick={() => handleDelete(reminder.id)}
                          style={{ padding: '4px 8px', fontSize: '0.8rem' }}
                        >
                          🗑️
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t.reminderTitle}</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder={t.reminderTitlePlaceholder}
                required
              />
            </div>
            <div className="form-group">
              <label>{t.reminderDate}</label>
              <input
                type="datetime-local"
                value={formData.reminder_date}
                onChange={(e) => setFormData({ ...formData, reminder_date: e.target.value })}
                required
              />
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setShowAddForm(false)}>
                {t.cancel}
              </button>
              <button type="submit" className="btn btn-primary">
                {t.save}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ReminderModal;

